import { config as cloudflareConfig } from './config.cloudflare';

export const config = {
    ...cloudflareConfig,
    USER_EMAIL: '' as string,
};
